import Select, { MultiValue } from 'react-select'

import { Button } from '@/view/components/ui/button'
import { BasicFilter } from '@/view/components/BasicFilter'
import { FilterSelectStyle } from '@/view/components/BasicFilter/FilterSelectStyle'
import { OptionType } from '@/app/utils/optionSelectType'

interface SupportRequestFilterProps {
  statusOptions: OptionType[]
  selectedStatusOptions: MultiValue<OptionType>
  onSelectStatus: (options: MultiValue<OptionType>) => void

  reasonOptions: OptionType[]
  selectedReasonOptions: MultiValue<OptionType>
  onSelectReason: (options: MultiValue<OptionType>) => void

  onClearFilter: () => void
}

export const SupportRequestFilter = ({
  statusOptions,
  selectedStatusOptions,
  onSelectStatus,
  reasonOptions,
  selectedReasonOptions,
  onSelectReason,
  onClearFilter,
}: SupportRequestFilterProps) => {
  const { DropdownIndicator, customStyles } = FilterSelectStyle({
    isMulti: true,
  })

  return (
    <BasicFilter>
      <div className="space-y-4 p-4">
        <div className="space-y-2">
          <h3 className="font-medium text-black04">Status</h3>
          <Select
            options={statusOptions}
            isMulti
            onChange={onSelectStatus}
            value={selectedStatusOptions}
            placeholder="Selecione o(s) status"
            styles={customStyles}
            components={{
              IndicatorSeparator: () => null,
              DropdownIndicator,
            }}
          />
        </div>

        <div className="space-y-2">
          <h3 className="font-medium text-black04">Motivo</h3>
          <Select
            options={reasonOptions}
            isMulti
            onChange={onSelectReason}
            value={selectedReasonOptions}
            placeholder="Selecione o(s) motivo(s)"
            styles={customStyles}
            components={{
              IndicatorSeparator: () => null,
              DropdownIndicator,
            }}
          />
        </div>
      </div>
      <div className="my-5 w-full border-b-[1px] border-gray01" />
      <div className="flex items-center justify-end p-4">
        <Button
          onClick={onClearFilter}
          variant="outline"
          className="rounded-full bg-gray02 text-xs font-bold"
        >
          Limpar
        </Button>
      </div>
    </BasicFilter>
  )
}
